import { create } from 'zustand';

/** Which of the shell's own dialogs is open. Only one at a time. */
export type ShellDialog = 'palette' | 'help' | null;

interface ShellUiState {
  dialog: ShellDialog;
  open: (dialog: Exclude<ShellDialog, null>) => void;
  close: () => void;
}

export const useShellUi = create<ShellUiState>((set) => ({
  dialog: null,
  open: (dialog) => set({ dialog }),
  close: () => set({ dialog: null }),
}));
